var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-switch',{attrs:{"loading":_vm.loading,"inset":"","color":"#0B3F67"},on:{"change":_vm.activarEnfoque},model:{value:(_vm.estadoActual),callback:function ($$v) {_vm.estadoActual=$$v},expression:"estadoActual"}})}
var staticRenderFns = []

export { render, staticRenderFns }